import { Rest } from '../../../../util/rest';

const BASE_PATH = '/rest/ai-dynamic-forms';
const PUBLIC_BASE_PATH = `/${Rest.contextPath}${BASE_PATH}`;

const parsePublicResponse = async (response) => {
  if (!response.ok) {
    const error = new Error('Dynamic Forms public request failed');
    error.status = response.status;
    try {
      error.payload = await response.json();
    } catch (_ignored) {
      error.payload = null;
    }
    throw error;
  }

  return response.json();
};

const publicFetch = (path, options = {}) => fetch(`${PUBLIC_BASE_PATH}${path}`, {
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  },
}).then(parsePublicResponse);

export function loadDynamicFormsData(user) {
  return Promise.all([
    Rest.authFetch(user, `${BASE_PATH}/clients`),
    Rest.authFetch(user, `${BASE_PATH}/templates`),
    Rest.authFetch(user, `${BASE_PATH}/forms`),
  ]).then(([clients, templates, forms]) => ({ clients, templates, forms }));
}

export function saveDynamicFormsClient(user, payload) {
  return Rest.authFetch(user, `${BASE_PATH}/clients`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function deleteDynamicFormsClient(user, id) {
  return Rest.authFetch(user, `${BASE_PATH}/clients/${id}`, {
    method: 'DELETE',
  });
}

export function saveDynamicFormsTemplate(user, payload) {
  return Rest.authFetch(user, `${BASE_PATH}/templates`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function deleteDynamicFormsTemplate(user, id) {
  return Rest.authFetch(user, `${BASE_PATH}/templates/${id}`, {
    method: 'DELETE',
  });
}

export function saveDynamicFormsForm(user, payload) {
  return Rest.authFetch(user, `${BASE_PATH}/forms`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export function deleteDynamicFormsForm(user, id) {
  return Rest.authFetch(user, `${BASE_PATH}/forms/${id}`, {
    method: 'DELETE',
  });
}


export function downloadDynamicFormsResponsesCsv(user, formId, timeZoneId = null) {
  const query = timeZoneId ? `?timezone=${encodeURIComponent(timeZoneId)}` : '';
  return Rest.authFetch(user, `${BASE_PATH}/forms/${formId}/responses.csv${query}`).then((response) => response.text());
}

export function getDynamicFormsShareLink(user, formId) {
  return Rest.authFetch(user, `${BASE_PATH}/forms/${formId}/share-link`);
}

export function createDynamicFormsShareLink(user, formId, payload = {}) {
  return Rest.authFetch(user, `${BASE_PATH}/forms/${formId}/share-link`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function revokeDynamicFormsShareLink(user, formId) {
  return Rest.authFetch(user, `${BASE_PATH}/forms/${formId}/share-link`, {
    method: 'DELETE',
  });
}

export function loadPublicDynamicFormsForm(token) {
  return publicFetch(`/public/forms/${encodeURIComponent(token)}`);
}

export function savePublicDynamicFormsDraft(token, data, responseUid = null) {
  return publicFetch(`/public/forms/${encodeURIComponent(token)}/draft`, {
    method: 'PUT',
    body: JSON.stringify({ data, ...(responseUid ? { responseUid } : {}) }),
  });
}

export function submitPublicDynamicFormsForm(token, data, responseUid = null) {
  return publicFetch(`/public/forms/${encodeURIComponent(token)}/submit`, {
    method: 'POST',
    body: JSON.stringify({ data, ...(responseUid ? { responseUid } : {}) }),
  });
}
